import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { ReactComponent as MenuIcon } from '../../../assets/images/menu-icon.svg';
import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import { getPersonsFullName } from '../../../utils/misc-utils';

const centroLogo = process.env.PUBLIC_URL + '/Logo-Centro.png';

const Header = (props: { className?: string; isDesktop: boolean; onMenuIconClick: () => void }): JSX.Element => {
  const { className, onMenuIconClick } = props;
  const { user, handleLogout } = useAuth();
  const [isDesktop, setIsDesktop] = useState<boolean>(props.isDesktop);

  useEffect(() => {
    setIsDesktop(props.isDesktop);
  }, [props.isDesktop, user]);

  // Get the user's name and initials
  const fullName = user ? getPersonsFullName(user) : 'Current User';
  const initials = fullName
    ? fullName
        .match(/(\b\S)?/g)
        ?.join('')
        .match(/(^\S|\S$)?/g)
        ?.join('')
        .toUpperCase()
    : 'CU';

  // Create a menu reference
  const menu = useRef<Menu>(null);

  const menuItems = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        handleLogout({ redirect: '/login' });
      },
    },
  ];

  return (
    <div
      className={classNames(
        'flex flex-row justify-between items-center px-4 bg-[var(--topbar-bg-color)] border-b border-gray-100',
        className
      )}
    >
      <div className="flex flex-row items-center gap-2">
        {!isDesktop && (
          <>
            <Button
              className="p-button-text text-gray-400 p-2 hover:text-gray-600 focus:shadow-none"
              onClick={() => onMenuIconClick()}
            >
              <MenuIcon title="menu" />
            </Button>
            <Link to="/">
              <img src={centroLogo} alt="Centro Logo" style={{ height: '28px' }} />
            </Link>
          </>
        )}
      </div>

      {user && (
        <div className="flex items-center gap-3">
          <span className="text-[0.85rem] text-gray-600 font-medium hidden sm:inline">{fullName}</span>
          <Avatar
            label={initials}
            shape="circle"
            className="bg-[#0a1f3d] text-white text-[0.75rem]"
            style={{ width: '34px', height: '34px' }}
          />
          <Menu model={menuItems} popup ref={menu} />
          <Button
            className="p-button-text text-gray-400 p-1.5 hover:text-gray-600 focus:shadow-none"
            onClick={(e) => menu.current && menu.current.toggle(e)}
          >
            <i className="pi pi-chevron-down text-[0.65rem]"></i>
          </Button>
        </div>
      )}
    </div>
  );
};

export default Header;
